import {BrowserRouter, Route, Switch} from "react-router-dom";
import Main from "./containers/main";
import Onboarding from "./containers/onboarding";
import Score from "./containers/score";
import Tutorial from "./containers/tutorial";
import Welcome from "./containers/welcome";

function AppRouter() {
  return (
    <div style={{}}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Welcome}></Route>
          <Route exact path="/main" component={Main}></Route>
          <Route exact path="/score" component={Score}></Route>
          <Route exact path="/onboarding" component={Tutorial}></Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default AppRouter;
